import { ButtonBase, Typography } from '@material-ui/core'
import React, { useState } from 'react'

import { persianRegex } from '../../helpers/regex'
import { lang } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { CancelPolicy } from '../../types/cancelAndModifyPolicies'
import RatePlansPoliciesActionModal from '../RatePlansPolicies/RatePlansPoliciesActionModal'
import { PolicyRowMenu } from './PolicyRowMenu'
import useStyles from './styles/PoliciesTable.styles'

interface PolicyRowProps {
  data: CancelPolicy
  providerCode: string
}

const PolicyRow: React.FC<PolicyRowProps> = ({ data, providerCode }) => {
  const [modalIsOpen, setmodalIsOpen] = useState<boolean>(false)
  const classes = useStyles()

  const isPersian = persianRegex.test(data.basicDetails.name)

  return (
    <div className={classes.tableRowRoot}>
      <ButtonBase
        className={classes.tableRow}
        component={LocalizedLink}
        to={`/policies/cancel-policies/${providerCode}/${data.basicDetails.id}/edit`}>
        <div className={classes.nameCell}>
          <Typography
            variant="h4"
            style={isPersian ? { fontFamily: 'IranSans' } : undefined}>
            {data.basicDetails.name}
          </Typography>
        </div>
        <div className={classes.descriptionCell}>
          <div
            dangerouslySetInnerHTML={{
              __html:
                lang === 'fa'
                  ? data.basicDetails.descriptionTranslatedList[0].value
                  : data.basicDetails.description
            }}
          />
        </div>
      </ButtonBase>
      <div>
        <PolicyRowMenu
          id={data.basicDetails.id}
          openModal={() => setmodalIsOpen(true)}
          providerCode={providerCode}
        />
      </div>{' '}
      <RatePlansPoliciesActionModal
        isOpen={modalIsOpen}
        onClose={() => setmodalIsOpen(false)}
        data={data.table}
      />
    </div>
  )
}

export default PolicyRow
